module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-REDDIT.fce88b30.png";